import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Icon,
  SimpleGrid,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { HeaderCard } from "../../../../components/headerCard";
import { useEffect, useRef, useState } from "react";
import { OfficeDTO } from "../../../../dtos/OfficeDTO";
import { RiCloseFill, RiPencilFill } from "react-icons/ri";
import { api } from "../../../../service/api";

export function ListOffices() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const [officeInfo, setOfficeInfo] = useState<OfficeDTO>({} as OfficeDTO);

  const [officeData, setOfficeData] = useState<OfficeDTO[]>([]);

  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const cancelRef = useRef<any>(null);

  async function deleteOffice(officeId: string) {
    try {
      setLoadingDelete(true);
      await api.delete(`company/office/delete/${officeId}`);
      toast({
        position: "top-right",
        title: "Produto",
        description: "Unidade de gestão removido com sucesso.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        position: "top-right",
        title: "Produto",
        description: "Não foi possível remover a unidade de gestão.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    } finally {
      setLoadingDelete(false);
      onClose();
      setOfficeInfo({} as OfficeDTO);
      getOffices();
    }
  }

  async function getOffices() {
    try {
      setLoading(true);
      const response = await api.get("company/office/list");
      setOfficeData(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getOffices();
  }, []);

  return (
    <Box>
      <HeaderCard
        title="UNIDADES DE GESTÃO"
        titleButton="Nova UG"
        link="/unidade-de-gestao/nova"
      />

      {loading && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={500}
        >
          <Spinner
            color="green.600"
            emptyColor="white"
            thickness="4px"
            size="xl"
            h={100}
            w={100}
          />
        </Box>
      )}

      <SimpleGrid
        flex="1"
        gap="4"
        minChildWidth="320px"
        alignItems="flex-start"
        px={1}
        py={1}
      >
        {officeData.length > 0 && !loading && (
          <Box p="4" borderRadius={8} height={500}>
            <TableContainer>
              <Table variant="striped" colorScheme="gray" size="sm">
                <Thead>
                  <Tr bg="green.600" height="10">
                    <Th color="white">NOME DA UG</Th>
                    <Th color="white">CNPJ</Th>
                    <Th color="white">N CENTRO DE CUSTO</Th>
                    <Th color="white" textAlign="center">
                      RESPONSÁVEL
                    </Th>
                    <Th color="white" textAlign="center">
                      MUNICÍPIO/UF
                    </Th>
                    <Th color="white">TELEFONE</Th>
                    <Th color="white" textAlign="center">
                      AÇÕES
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {officeData.map((item, index) => (
                    <Tr key={index}>
                      <Td>{item.name_ug}</Td>
                      <Td>{item.cnpj}</Td>
                      <Td textAlign="center">{item.cost_center_number}</Td>
                      <Td textAlign="center">{item.responsible}</Td>
                      <Td>{item.city}</Td>
                      <Td textAlign="center">{item.phone}</Td>
                      <Td textAlign="center" width="10">
                        <Button
                          size="sm"
                          fontSize="sm"
                          as="a"
                          href={`/unidade-de-gestao/atualizar/${item.id}`}
                        >
                          <Icon fontSize="16px" as={RiPencilFill} />
                        </Button>
                        <Button
                          size="sm"
                          ml={1}
                          fontSize="sm"
                          onClick={() => {
                            setOfficeInfo(item);
                            onOpen();
                          }}
                        >
                          <Icon fontSize="16px" as={RiCloseFill} />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </SimpleGrid>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
        motionPreset="slideInBottom"
        closeOnEsc={false}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Remover unidade de gestão
            </AlertDialogHeader>

            <AlertDialogBody>
              {!loadingDelete && (
                <Text>
                  Deseja remover a unidade de gestão:{" "}
                  <strong>{officeInfo?.name_ug}</strong>
                </Text>
              )}

              {loadingDelete && (
                <Flex width="100%" alignItems="center" justifyContent="center">
                  <Spinner
                    color="green.600"
                    emptyColor="white"
                    thickness="4px"
                    size="xl"
                    h={50}
                    w={50}
                  />
                </Flex>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              {!loadingDelete && (
                <>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      deleteOffice(officeInfo?.id);
                    }}
                  >
                    Sim
                  </Button>
                  <Button ml={3} onClick={onClose}>
                    Nāo
                  </Button>
                </>
              )}
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}
